import React, { useState, useContext, useEffect,useRef } from 'react';
import '../../../assets/css/chatEstilos.css'
import '../../../assets/css/views/recargas.css'

import { Modal } from '../../components/modal/Modal';

import { ModalRecarga } from '../../components/modal/ModalRecarga';

import { BotonesEstado } from '../../components/buttons/BotonEstado';
import { notify, soloDecimal, formatState, primeraLetraMayuscula } from '../../../utils/utils'
import { SocketContext } from '../../../context/provider/SocketProvider'
import { Tooltip } from '../../components/utils/Tooltip';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { useRecargas } from '../../../hooks/useRecargas';
import { useModal } from '../../../hooks/useModal';
import sonidoRecarga from '../../../assets/sound/sonidoRecarga.mp3'
import { useHistorialRecargas } from '../../../hooks/useHistorialRecargas';
import { useAmonestaciones } from '../../../hooks/useAmonestaciones';
import { SearchTable } from '../../components/utils/SearchTable';
import { UserContext } from '../../../context/provider/UserProvider';
import { useChatOnline } from '../../../hooks/useChatOnline';
import fotoChat from '../../../../src/assets/images/fotousuarioBeex.fw.png'
import fotobeexserver from '../../../../src/assets/images/fotousuarioBeexserver.fw.png'
import { soloNumero } from '../../../utils/utils';
import { useImagenaTexto } from '../../../hooks/useImagenaTexto';
import { useOperaciones } from '../../../hooks/useOperaciones';
import { useHistory } from "react-router-dom";
import { useReportes } from '../../../hooks/useReportes';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { DatePickerDoble } from '../../components/pickers/DatePickerDoble';

const urlMinio = process.env.REACT_APP_BEEDRONE_WEB_API_MINIO

export const ReporteRecargas = () => {
    
    const history = useHistory();
    const {listarRecargasReporte, recargasReporte} = useReportes()   
    const { bancos } = useRecargas();
    const [ isOpenModalFoto, openModalFoto, closeModalFoto ] = useModal()
    const [ fotoVoucher, setFotoVoucher ] = useState()
    const classNameInput2 = "p-2 caret-input text-white containerScroll h-[60px] rounded mt-[5px] px-2 w-full bg-zinc-900 text-base focus:outline-none focus:ring-1 focus:ring-blue-500"
    const classNameInput = " caret-input  text-white h-[30px] rounded px-2 w-[240px] bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center text-l  caret-input"
    const [ startDate, setStartDate ] = useState(new Date())
    const [ endDate, setEndDate ] = useState(new Date())
    const [ recargaDate, setRecargaDate ] = useState(new Date())
    const { stateSocket } = useContext(SocketContext);
    const { stateUser, signIn } = useContext(UserContext);
    const [ isOpenModalRecarga, openModalRecarga, closeModalRecarga ] = useModal()
    const [ urlBancoElegido , setUrlBancoElegido ] = useState()
    const idTablaRecargas = "tablaRecargas"
    const [ bancoSeleccionado, setBancoSeleccionado ] = useState(0)
    const [ UIDSeleccionado, setUIDSeleccionado ] = useState("")
 
    useEffect(() => {
        listarRecargasReporte(startDate,endDate);
    }, [startDate, endDate])
    
    useEffect(()=>{
        // listarEntidadesBancarias()
    },[])

    return (
        <>
            <ContenedorParametros titulo='Recargas'>
                <DatePickerDoble
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <div>
                    <select className={`${classNameInput} containerScroll w-[150px]`}  onChange={(e) =>setBancoSeleccionado(e.target.value)}>
                        <option value={0}>--Todos--</option>
                            {
                                bancos?.map((banco,i)=>{
                                    return <option key={banco.codEntidadBancariaCuenta} value={banco.codEntidadBancariaCuenta}>{banco.nomBanco}</option>
                                })
                            }
                    </select>   
                </div>
                <div>
                    <select className={`${classNameInput} containerScroll w-[150px]`}  onChange={(e) =>setUIDSeleccionado(e.target.value)}>
                        <option value={0}>--Todos--</option>
                            {
                                // bancos?.map((calificacion,i)=>{
                                //     return <option key={calificacion.codEstrella} value={calificacion.codEstrella}>{calificacion.nomEstrella}</option>
                                // })
                            }
                    </select>   
                </div>
                <BotonProcesar onClick={() => listarRecargasReporte(startDate, endDate, bancoSeleccionado, UIDSeleccionado )} ></BotonProcesar>
                <SearchTable tablaId={idTablaRecargas}></SearchTable>
            </ContenedorParametros>

           
            <div className=" containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla" >
            {/* <div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla" style={{position: 'relative', height: '400px', overflow: 'auto'}}> */}

                <table id={idTablaRecargas} className="table">
                    <thead>
                        <tr>
                            <th className="w-[30px]">N</th>
                            <th className='w-[180px]'>FECHA/HORA</th>
                            <th className='w-[250px]'>USUARIO Biix</th>
                            <th className='w-[250px]'>BANCO</th>
                            <th className='w-[250px]'>N. OPERACION</th>
                            <th className="text-right w-[60px] ">IMPORTE</th>
                            <th>ATENCIÓN</th>
                            <th>COMENTARIO</th>
                            <th className="w-[80px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {  
                            recargasReporte?.length > 0 
                            ? recargasReporte?.map((r, i) => {

                                return (
                                    <tr key={i+1} className={` `}>
                                        <td>{++i}</td>
                                        <td className="text-center">{r.fechaHoraCreacion}</td>
                                        <td className="text-center">{r.uidCreacion}</td>
                                        <td className="text-center">{r.nomEntidadBancaria}</td>
                                        <td className="text-center">{r.nroOperacion}</td>
                                        <td className="text-right">S/{Number(r.montoVoucher).toFixed(2)}</td>
                                        <td className="text-center">{r.uidAsignadoAtencion}</td>
                                        <td className="max-w-[100px]">
                                            {
                                                r.comentario !== null &&
                                                <>
                                                    <div data-tip data-for={'id-tooltip-' + r.nroOperacion} className="w-full whitespace-nowrap overflow-hidden text-ellipsis">{r.comentario}</div>
                                                    <Tooltip id={'id-tooltip-' + r.codPeticion}>
                                                        {r.comentario}
                                                    </Tooltip>
                                                </>
                                            }
                                        </td>
                                        <td className="text-center">
                                            {
                                                r.nomVoucher !== null &&
                                                <>
                                                        <img 
                                                            src={`${urlMinio}/Archivo/verImagen?NombreCarpeta=${r.nomCarpetaVoucher}&NombreImagen=${r.nomVoucher}`} 
                                                            alt={r.nomVoucher}
                                                            className="w-7 h-7 fa fa-picture-o text-white-600 text-lg botonFoto" 
                                                            onClick={()=> {openModalFoto();setFotoVoucher(`${urlMinio}/Archivo/verImagen?NombreCarpeta=${r.nomCarpetaVoucher}&NombreImagen=${r.nomVoucher}`);
                                                        }}>
                                                        </img>

                                                </>
                                            }
                                            {/* {
                                                r.nomVoucher !== null &&
                                                <>
                                                        <button 
                                                            className="fa fa-picture-o text-white-600 text-lg botonFoto" 
                                                            onClick={()=> {openModalFoto();setFotoVoucher(`${urlMinio}/Archivo/verImagen?NombreCarpeta=${r.nomCarpetaVoucher}&NombreImagen=${r.nomVoucher}`);
                                                        }}>
                                                            <i className="fa fa-picture text-black-600 text-lg"></i>
                                                        </button>

                                                </>
                                            } */}
                                        </td>
                                    </tr>

                                )
                            })
                            : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }

                    </tbody>
                    {/* <tfoot className='bg-[#2e5289]'>
                        <tr >
                            <td colSpan="5" className="text-right font-bold">Total:</td>
                            <td className="text-right">
                                S/{recargasReporte.reduce((acc, curr) => acc + Number(curr.montoVoucher), 0).toFixed(2)}
                            </td>
                            <td colSpan="3"></td>
                        </tr>
                    </tfoot> */}
                </table>
                
            </div>
                <div className="bg-[#2e5289] text-white absolute bottom-0 w-full py-2" style={{textAlign: 'center', paddingRight: '20px'}}>
                    Monto Total: S/{recargasReporte?.reduce((acc, curr) => acc + Number(curr.montoVoucher), 0).toFixed(2)}
                </div>




            <Modal 
                isOpen={isOpenModalFoto} 
                closeModal={closeModalFoto}
                action={closeModalFoto} 
                title={`Foto Voucher`}
                textButtons = {{
                    confirm: ''
                }}
                validButton = {{
                    confirm: false,
                    denied: false
                }}        
            >
                <div className='flex items-center justify-center w-full h-full min-h-0'>
                    <img 
                        src={fotoVoucher} 
                        className="max-w-full max-h-full object-contain rounded"
                        alt='foto'
                    />
                </div>

            </Modal>

        </>
    )
}
